import { Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import views, { View } from "../../data/views.data";
import VspPortalContext from "../../store/VspPortalContext";


type LeftSidebarProps = {
    
    closeDrawer: () => void;
    drawerOpen: boolean;

}


export const LeftSidebar: React.FC<LeftSidebarProps> = ( props: LeftSidebarProps ) => {

    const { state } = useContext( VspPortalContext );
    
    const { drawerOpen, closeDrawer } = props;

    const location = useLocation( );
    const index = views.find( view => view.path === location.pathname.toLowerCase( ) )?.index;
    const [selectedIndex, setSelectedIndex] = useState( index ?? 0 );
    const handleListItemClick = ( index: number ) => setSelectedIndex( index );

    if (index && index !== selectedIndex) {
        setSelectedIndex( index );
    }

    const listItems = views.filter( ( view: View ) => view.userGroups.filter( e => state.userGroups.includes ( e ) ).length > 0 ).map( (view: View) => 
    
        <ListItem button component={NavLink} to={view.path} selected={ selectedIndex === view.index } onClick={( ) => handleListItemClick(view.index)} key={view.index}>
            <ListItemIcon>
                { view.icon }
            </ListItemIcon>
            <ListItemText primary={view.text} />
        </ListItem>
    
    );

    return(
        <Drawer open={drawerOpen} variant="persistent" anchor="left" PaperProps={{sx: { width: "300px;" }}}>

            <Toolbar variant="dense" disableGutters>

                <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={closeDrawer}> 
                    <MenuIcon />
                </IconButton>

                <Typography
                    component="h1"
                    variant="h6"
                    color="inherit"
                    sx={{fontWeight:'bold'}}
                    noWrap>
                    Village Ops
                </Typography>

            </Toolbar>

            <List sx={{ paddingTop:'0px;' }}>
                {listItems}
            </List>

        </Drawer>
    );
};